import cn from "classnames";
import { FC } from "react";
import { Text } from "../Text";
import type { CaseStudyStatsProps } from "./CaseStudyStats.types";
import { KeyIntegrationLogoList } from "./KeyIntegrationLogoList";

const CaseStudyStatsMobile: FC<CaseStudyStatsProps> = ({
  industry,
  companySize,
  keyIntegrations,
  className,
}) => {

  const labelClassName = "uppercase text-gray-700";
  const valueClassName = "font-500 text-blue-1000";
  const statContainerClassName = "flex flex-col gap-md text-left";

  return (
    <section
      className={cn("bg-white px-md py-6", className)}
    >
      <div className="mx-auto w-full max-w-grid">
        {/* Industry */}
        <div className={cn(statContainerClassName, "pb-3")}>
          <Text type="micro1" className={labelClassName}>{industry.label}</Text>
          <Text type="p1" className={valueClassName}>{industry.value}</Text>
        </div>

        {/* Company size */}
        <div className={cn(statContainerClassName, "border-t border-solid border-gray-200 py-3")}>
          <Text type="micro1" className={labelClassName}>{companySize.label}</Text>
          <Text type="p1" className={valueClassName}>{companySize.value}</Text>
        </div>

        {/* Key integrations */}
        <div className={cn(statContainerClassName, "border-t border-solid border-gray-200 pt-3")}>
          <Text type="micro1" className={labelClassName}>{keyIntegrations.label}</Text>
          <KeyIntegrationLogoList logos={keyIntegrations.logos} />
        </div>
      </div>
    </section>
  );
};

export { CaseStudyStatsMobile };
